import React from 'react';
import './style.scss';

const NftAvatar = ({ url }) => {
    return (
        <div id="nftAvatarContainer">
            <img id="nftAvatar" src={`${url}?t=${new Date().getTime()}`} alt="" />
        </div>
    )
};

export default NftAvatar;